import React from 'react';
import createReactClass from 'create-react-class';
import ReviewMixin from '../mixins/mixin';
import './index.scss';

var BookingReviewDefault = createReactClass({
  displayName: 'BookingReview-Mobile-AnyGuide',

  mixins: [ReviewMixin],

  getDefaultProps: function () {
    return {
      theme: 't-Mobile',
    };
  },

  render: function () {
    return (
      <div className="BookingReview-Container t-Mobile">
        {this._renderStep()[this.state.step]}
      </div>
    );
  },
});

export default BookingReviewDefault;
